import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosApi";
import "../LoginForm/LoginForm.css";
import axios from 'axios';
const LoginForm = () => {
  const [scimUsername, setScimUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginFailed, setLoginFailed] = useState(false);

  // useEffect(() => {
  //   localStorage.clear();
  //   setLoginFailed(false);
  // }, []);

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const response = await axiosInstance.post("token/obtain/", {
  //       scim_username: scimUsername,
  //       password: password,
  //     });

  //     // Wijzig de default Authorization-header zodat deze de verkregen JWT access-token bevat
  //     axiosInstance.defaults.headers["Authorization"] =
  //       "JWT " + response.data.access;

  //     // Sla de access- en refreshtokens op in de lokale opslag
  //     localStorage.setItem("access_token", response.data.access);
  //     localStorage.setItem("refresh_token", response.data.refresh);

  //     // Sla de e-mail van de ingelogde user op
  //     localStorage.setItem("current_user", scimUsername);

  //     window.location = "/app/";
  //     return response;
  //   } catch (error) {
  //     this.setState({
  //       loginFailed: true,
  //     });
  //     alert("Inloggen mislukt");
  //     setLoginFailed(true);
  //     throw error;
  //   }
  // };


  const handleSubmit = async (event) => {
    event.preventDefault();  
    // axios.request(config)
    // .then((response) => {
    //   console.log(JSON.stringify(response.data));
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
    
  };

  return (
    <div>
      <br />
      <form onSubmit={handleSubmit} className="box" id="login-form">
        <h1 className="title">Inloggen</h1>
        <h2
          className="subtitle"
          style={{ display: loginFailed ? "block" : "none" }}
        >
          Verkeerde combinatie
        </h2>
        <div className="field">
          <p className="control has-icons-left has-icons-right">
            <input
              name="username"
              className="input"
              onChange={(e) => setScimUsername(e.target.value)}
              // type="email"
              placeholder="Username"
              required={true}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-envelope"></i>
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control has-icons-left">
            <input
              name="password"
              className="input"
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Password"
              required={true}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-lock"></i>
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control">
            <button className="button is-primary is-outlined">Login</button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
